/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link, Switch, Redirect } from 'react-router-dom';
import { toAbsoluteUrl } from '../../../../_metronic/_helpers';
import { ContentRoute } from '../../../../_metronic/layout';
import Login from './Login';
import Registration from './Registration';
import { ForgotPassword } from './ForgotPassword.tsx';
import '../../../../_metronic/_assets/sass/pages/login/login-1.scss';
import Signup from './Signup';

export function AuthPage() {
	return (
		<>
			<div className='d-flex flex-column flex-root'>
				{/*begin::Login*/}
				<div
					className='login login-1 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white'
					id='kt_login'
				>
					{/*begin::Aside*/}
					<div className='login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10'>
						{/*begin: Aside Container*/}
						<div className='d-flex flex-row-fluid flex-column justify-content-between '>
							{/* start:: Aside header */}

							{/* end:: Aside header */}

							{/* start:: Aside content */}
							<div className='flex-column-fluid d-flex flex-column justify-content-center'>
								<Link to='/'>
									<img
										alt='Logo'
										className='img-fluid'
										src={toAbsoluteUrl('/assets/squadded.png')}
									/>
								</Link>
							</div>
							{/* end:: Aside content */}

							{/* start:: Aside footer for desktop */}
							<div className='d-none flex-column-auto d-lg-flex justify-content-between mt-10'>
								<div className='opacity-70 font-weight-bold	text-white'>&copy; 2020 Squadded</div>
								<div className='d-flex'>
									<a
										rel='noopener noreferrer'
										target='_blank'
										href='https://www.squadded.co/privacy-policy'
										className='text-white'
									>
										Privacy
									</a>
									<a href='mailTo:support@squadded.co' target='_top' className='text-white ml-10'>
										Contact
									</a>
								</div>
							</div>
							{/* end:: Aside footer for desktop */}
						</div>
						{/*end: Aside Container*/}
					</div>
					{/*begin::Aside*/}

					{/*begin::Content*/}
					<div className='flex-row-fluid d-flex flex-column position-relative overflow-hidden'>
						{/*begin::Content header*/}
						<div className='position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10'>
							<span className='font-weight-bold text-dark-50'>Don't have an account yet?</span>
							<Link to='/onboarding' className='font-weight-bold ml-2' id='kt_login_signup'>
								Sign Up!
							</Link>
						</div>
						{/*end::Content header*/}

						{/* begin::Content body */}
						<div className='d-flex flex-column-fluid flex-center mt-30 mt-lg-0'>
							<Switch>
								<ContentRoute path='/auth/login' component={Login} />
								<ContentRoute path='/auth/registration' component={Registration} />
								<ContentRoute path='/auth/signup' component={Signup} />
								<ContentRoute path='/auth/forgot-password' component={ForgotPassword} />
								<Redirect from='/auth' exact={true} to='/auth/login' />
								<Redirect to='/auth/login' />
							</Switch>
						</div>
						{/*end::Content body*/}

						{/* begin::Mobile footer */}
						<div className='d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5'>
							<div className='text-dark-50 font-weight-bold order-2 order-sm-1 my-2'>
								&copy; 2020 Squadded
							</div>
							<div className='d-flex order-1 order-sm-2 my-2'>
								<Link to='/terms' className='text-dark-75 text-hover-primary'>
									Privacy
								</Link>
								<Link to='/terms' className='text-dark-75 text-hover-primary ml-4'>
									Legal
								</Link>
								<Link to='/terms' className='text-dark-75 text-hover-primary ml-4'>
									Contact
								</Link>
							</div>
						</div>
						{/* end::Mobile footer */}
					</div>
					{/*end::Content*/}
				</div>
				{/*end::Login*/}
			</div>
		</>
	);
}
